import { create } from "zustand";

export type ToastType = "success" | "error" | "info";

export interface ToastItem {
  id: number;
  type: ToastType;
  message: string;
  duration: number;
  leaving: boolean;
}

interface ToastState {
  toasts: ToastItem[];
  push: (type: ToastType, message: string) => void;
  dismiss: (id: number) => void;
}

export const TOAST_DURATION: Record<ToastType, number> = {
  success: 4000,
  info: 5000,
  error: 7000,
};
export const MAX_TOASTS = 4;
export const EXIT_MS = 180;

let sequence = 0;

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],
  push: (type, message) => {
    const duplicate = get().toasts.find(
      (toast) =>
        !toast.leaving && toast.type === type && toast.message === message
    );

    if (duplicate) get().dismiss(duplicate.id);

    const toast: ToastItem = {
      id: ++sequence,
      type,
      message,
      duration: TOAST_DURATION[type],
      leaving: false,
    };
    set((state) => ({
      toasts: [...state.toasts, toast].slice(-MAX_TOASTS),
    }));
  },
  dismiss: (id) => {
    const target = get().toasts.find((toast) => toast.id === id);
    if (!target || target.leaving) return;

    set((state) => ({
      toasts: state.toasts.map((toast) =>
        toast.id === id ? { ...toast, leaving: true } : toast
      ),
    }));
    setTimeout(() => {
      set((state) => ({
        toasts: state.toasts.filter((toast) => toast.id !== id),
      }));
    }, EXIT_MS);
  },
}));

